// Add your custom JS here.
document.addEventListener('wpcf7submit', function (event) {

    if (event.detail.status === 'mail_sent') {

        const gate = document.getElementById('lead-gate');
        const locked = document.getElementById('locked-content');

        if (gate) {
            gate.style.display = 'none';
        }

        if (locked) {
            locked.style.display = 'block';
        }
    }

});